import { env } from '@/lib/env';
import {
    adminClient,
    inferAdditionalFields,
    organizationClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import type { auth } from './server';

export const authClient = createAuthClient({
    baseURL: env.NEXT_PUBLIC_APP_URL,
    plugins: [
        inferAdditionalFields<typeof auth>(),
        adminClient(),
        organizationClient(),
    ],
});

export const {
    signIn,
    signOut,
    signUp,
    useSession,
    useListOrganizations,
    useActiveOrganization,
    organization,
} = authClient;
